import React, { FC } from 'react';
import { Typography } from '@mui/material';
import { TextAnswers } from 'pages/Funds/components/ProcessManagement/TextAnswers';
import { foundSelectedOption } from 'pages/Funds/utils';
import theme from 'theme';
import { getNumberValue, gridLocalShortDate } from 'utilities';
import { DropdownAndDateAnswersProps } from './types';

const DropdownAndDateAnswers: FC<DropdownAndDateAnswersProps> = props => {
  const { task, isDropdown = false } = props;
  const { options, answers, children_questions: childrenQuestions } = task;

  return (
    <>
      {answers?.map(answer => (
        <React.Fragment key={answer.id}>
          <Typography
            style={{
              fontWeight: 400,
              color: theme.palette.black,
              fontSize: '1rem',
              display: 'inline',
            }}>
            {isDropdown
              ? foundSelectedOption({ id: getNumberValue(answer?.selected_choice), options })
              : gridLocalShortDate(answer?.date_answer)}
            {'. '}
          </Typography>
          {childrenQuestions?.map(question => (
            <TextAnswers key={question.id} answers={question.answers} />
          ))}
        </React.Fragment>
      ))}
    </>
  );
};

export default DropdownAndDateAnswers;
